import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ja from './locales/ja.json';

// Translations live in locales/*.json so that CI and the meta-tag generator
// can read them without parsing TypeScript. See scripts/validate-sites.mjs.
const resources = {
  en: { translation: en },
  ja: { translation: ja },
};

const savedLng = localStorage.getItem('i18nextLng');
const browserLng = navigator.language.split('-')[0];

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLng || (resources[browserLng as keyof typeof resources] ? browserLng : 'ja'),
    fallbackLng: 'ja',
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;